import React from 'react';

const variants = {
  primary:
    'bg-gradient-to-r from-cyan-500 to-blue-500 text-white hover:from-cyan-600 hover:to-blue-600',
  danger:
    'bg-gradient-to-r from-red-500 to-pink-500 text-white hover:from-red-600 hover:to-pink-600',
  success:
    'bg-green-500 text-white hover:bg-green-600',
  destructive:
    'bg-red-500 text-white hover:bg-red-600',
  secondary:
    'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50',
  ghost:
    'text-gray-700 hover:bg-gray-100',
};

const sizes = {
  xs: 'px-2 py-1 text-xs',
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-4 py-2.5 text-sm',
};

/**
 * @param {'primary'|'danger'|'success'|'destructive'|'secondary'|'ghost'} [variant]
 * @param {'xs'|'sm'|'md'|'lg'} [size]
 * @param {boolean} [loading]
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  onClick,
  children,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={[
        'inline-flex items-center justify-center gap-2 font-medium rounded-md',
        'transition-all disabled:opacity-60 disabled:cursor-not-allowed',
        variants[variant] ?? variants.primary,
        sizes[size] ?? sizes.md,
        className,
      ].join(' ')}
    >
      {loading && (
        <span className="animate-spin h-4 w-4 border-2 border-current border-t-transparent rounded-full" />
      )}
      {children}
    </button>
  );
}
